<style scoped>
.imageDiv {
  position: relative;
}
.imageDiv img {
  border-radius: 100%;
  border: 4px solid #d4dbf9;
  width: 77.5px;
}
.mainHeaderDiv {
  /* min-height: 130px; */
  height: inherit;
  padding: 0 20px;
}
.p-text-gray {
  color: #74788d !important;
}
.userPhone {
  color: #495057 !important;
  font-size: 14px;
}
.userPhone span {
  margin: 0 1px;
}
.userPhoneAddress {
  /* height: 130px; */
  height: inherit;
}
.popover-body {
  padding: 1px 1rem !important;
  color: #495057;
  margin-top: 0 !important;
  padding: 1rem 0.5rem;
  color: #495057;
}
.popOverDiv button:focus {
  outline: 0 !important;
  box-shadow: 0 0 0 0;
  border: none;
}
.popOverDiv button i {
  font-size: 25px;
  color: #556ee6;
  margin-left: 0.1vw;
}
.popOverDiv button {
  margin-left: 2%;
}
.p-noteDiv textarea {
  height: 100px !important;
  color: #74788d;
  border: 1px solid #ced4da;
  margin: 10px 0 0 0;
  padding: 5px 10px;
}
.p-noteDiv textarea:focus-visible {
  outline: 0 !important;
}
.p-noteDiv::placeholder {
  color: #74788d;
}
.rangeSliderMainDiv {
  padding: 15px 0 0 0;
}
.popover {
  top: 9px !important;
}
.popover-body {
  padding: 0.5rem !important;
  border-radius: 3px !important;
  color: #495057 !important;
  margin: 10px 0 0 0 !important;
  box-shadow: 0px 0px 4px -1px #495057 !important;
}
.p-whiteSpace {
  white-space: nowrap !important;
}
.userMobileDiv {
  margin-left: 1vw !important;
}
.userDefaultImg {
  font-size: 70px;
  color: #ccc;
}
.h117 {
  height: 117px !important;
}
.editPen {
  opacity: 0;
  font-size: 20px;
  position: absolute;
  border-radius: 50px;
  padding: 20px 25px;
  color: #fff;
  background-color: rgba(14, 14, 14, 0.5);
}
.editPen:hover {
  opacity: 1;
}
.showEditPen:hover,
.showEditPen:hover ~ .editPen,
.editPen:hover {
  cursor: pointer;
}
.showEditPen:hover ~ .editPen {
  opacity: 0.5;
}
.ellipses {
  width: 12em;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .popover-body {
  max-height: 250px !important;
  overflow-y: scroll;
}

::v-deep .popover-body::-webkit-scrollbar,
#my-note::-webkit-scrollbar {
  width: 5px;
}
::v-deep .popover-body::-webkit-scrollbar-track,
#my-note::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}
::v-deep .popover-body::-webkit-scrollbar-thumb,
#my-note::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #556ee6;
}
::v-deep .vue-slider-ltr .vue-slider-mark-label,
::v-deep .vue-slider-rtl .vue-slider-mark-label {
  margin-top: 4px !important;
}
</style>

<template>
  <b-row>
    <div class="d-flex mainHeaderDiv">
      <b-col lg="1">
        <div class="imageDiv d-flex flex-column align-items-center justify-content-center h117">
          <img
            v-if="userDetails.avataImageUrl || updatedAvatar"
            class="img-fluid showEditPen"
            :src="updatedAvatar ? updatedAvatar : userDetails.avataImageUrl"
            alt="avatar"
            @click="editAvatar"
          />
          <i v-else class="fas fa-user-circle userDefaultImg showEditPen" @click="editAvatar"></i>
          <i class="fa-regular fa-pencil editPen" @click="editAvatar"></i>
        </div>
        <b-modal id="chooseImage" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
          <template #modal-title>کراپ عکس</template>
          <div class="p-3">
            <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="updateUserAvatar($event)" />
          </div>
        </b-modal>
      </b-col>
      <b-col lg="8">
        <div class="d-flex flex-column justify-content-around centerMainDiv h117">
          <div class="row userPhoneAddress align-items-center">
            <b-col cols="12" lg="6" class="">
              <b-row>
                <b-col cols="6">
                  <div class="d-flex">
                    <span class="p-whiteSpace ellipses" data-bs-toggle="tooltip" :title="userDetails.firstName + ' ' + userDetails.lastName"
                      >{{ userDetails.firstName }} {{ userDetails.lastName }}</span
                    >
                    <!-- <span class="p-whiteSpace p-text-gray">({{ userDetails.role ? userDetails.role : 'مشتری مبتدی' }})</span> -->
                    <!-- TODO -->
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="d-flex justify-content-start userMobileDiv" data-bs-toggle="tooltip" :title="userDetails.mobile">
                    <span class="p-whiteSpace">تلفن همراه:</span><span class="ms-1 ellipses">{{ userDetails.mobile }}</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" class="">
              <div class="row">
                <div class="col-6 d-flex align-items-center" data-bs-toggle="tooltip" :title="userDetails.telephone">
                  <span class="p-whiteSpace">تلفن ثابت:</span><span class="ms-1 ellipses">{{ userDetails.telephone }}</span>
                </div>
                <div class="popOverDiv d-flex justify-content-end col-6">
                  <button v-b-popover.hover="userDetails.address.addressText" class="btn p-0 float-end">
                    <i class="fas fa-map-marker-alt"></i>
                  </button>
                </div>
              </div>
            </b-col>
          </div>
          <div class="row userPhoneAddress align-items-center">
            <b-col cols="6">
              <div class="">
                <FormTags :tags="userDetails.tag" @updateTag="updateTag($event)" />
              </div>
            </b-col>
            <b-col cols="6">
              <RangeSlider :modelValue="this.userDetails.customerSatisfactionRate" @rate="updateRate($event)" :options="sliderOptions" />
            </b-col>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="p-noteDiv">
          <textarea name="my-note" id="my-note" cols="30" rows="3" class="w-100" placeholder="یادداشت" :value="userDetails.adminNote" @change="updateAdminNote($event)"></textarea>
        </div>
      </b-col>
    </div>
  </b-row>
</template>

<script>
import RangeSlider from '../common/rangeSlider'
import FormTags from '../common/form/formModules/FormTags'
import fileMannager from '../../services/file'
import ImageCropper from '../../components/user/ImageCropper.vue'
import userDataProvider from '../../services/user'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'userDetail-header',
  components: {
    RangeSlider,
    FormTags,
    ImageCropper,
  },
  data() {
    return {
      cropperLoading: false,
      an: '',
      updatedAvatar: '',

      FormTagData: {
        newTagPlaceholder: 'اضافه کردن تگ',
        tags: [],
        newTag: '',
      },
      sliderOptions: {
        text: 'رضایت از مشتری',
        dotSize: 0,
        width: '100%',
        height: 7,
        contained: false,
        direction: 'rtl',
        dataLabel: 'label',
        dataValue: 'value',
        min: 0,
        max: 10,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 1,
        adsorb: false,
        lazy: true,
        tooltip: 'always',
        tooltipPlacement: 'top',
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: true,
        enableCross: true,
        fixed: false,
        order: true,
        marks: {
          0: '0',
          10: '10',
        },
        process: true,
        processStyle: { backgroundColor: '#556ee6' },
        tooltipStyle: { backgroundColor: '#556ee6', borderColor: '#556ee6', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px 1px' },
      },
    }
  },
  props: {
    userDetails: {},
  },
  methods: {
    updateAdminNote(e) {
      this.$emit('updateAdminNote', e.target.value)
    },
    updateTag(e) {
      this.$emit('updateTag', e)
    },
    updateRate(e) {
      this.$emit('updateRate', e)
    },
    updateUserAvatar(payload) {
      this.cropperLoading = true
      fileMannager
        .addImage({
          base64image: payload,
        })
        .then((res) => {
          // setTimeout(() => {
          this.updatedAvatar = res.data.data.downloadUrl
          this.cropperLoading = false
          this.$bvModal.hide('chooseImage')
          // this.formData.avataImageUrl = this.UserAvatar
          // }, 500)
          userDataProvider
            .updateImage({ peopleId: this.$route.params.id, url: res.data.data.downloadUrl })
            .then((res) => {})
            .catch((err) => {})
        })
        .catch((err) => {
          this.cropperLoading = false
        })
    },
    editAvatar() {
      this.$bvModal.show('chooseImage')
    },
  },
}
</script>
